import { LoginService } from './../../../service/login.service';
import { InfoService } from './../../../service/info.service';
import { Component, OnInit } from '@angular/core';
import { ParametrosService } from 'src/app/service/parametros.service';

@Component({
  selector: 'app-direcciones',
  templateUrl: './direcciones.component.html',
  styleUrls: ['./direcciones.component.scss']
})
export class DireccionesComponent implements OnInit {
  msjError: any;
  session: any;

  constructor(private parametrosService: ParametrosService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
  }

  filter = '';
  direccion: any[];
  numParametro: number;
  error: boolean;
  loading: boolean;
  noResults: boolean;

   async ngOnInit() {
    this.numParametro = 26004;
    this.error = false;
    this.msjError = '';
    this.loading = false;

    await this.getDirecciones();
  }

  async getDirecciones() {
    this.loading = true;
    try {
      const res = await this.parametrosService.fetchParametros(this.numParametro);

      if (!res || !res.ok) {
        this.error = true;
        this.msjError = res?.message || 'Error al obtener datos';
        this.direccion = [];
      } else {
        const data = (res as any).data || {};
        if (Array.isArray(data.parametros) && data.parametros.length) {
          this.direccion = data.parametros.filter(
            (p: any) => p.sIndicador02 === 'S' && p.sIndicador04 === 'S'
          );
          this.noResults = this.direccion.length === 0;
        } else {
          this.direccion = data || [];
          this.noResults = true;
        }
        this.error = false;
      }
    } catch (err) {
      console.error('Error getDireccion', err);
      this.error = true;
      this.msjError = 'Error inesperado';
      this.direccion = [];
    } finally {
      this.loading = false;
    }
  }
}